'use strict';

(function (global) {

  // Стандартный отступ плейсхолдеров
  const PLACEHOLDER_MARGIN = 20;

  // Способы масштабирования области предпросмотра
  const PREVIEW_SCALE = {
    FIT_HEIGHT: 'h',
    FIT_WIDTH: 'w',
    FIT_WINDOW: 'a',
  };

  /**
* Объект цикличный-итератор по направлениям вращения по сторонам света
* @object Directions
* @since 5.1.0.1523
*/
  const Directions = {
    index: 0,
    directions: ['N', 'E', 'S', 'W'], 
    next: function () {
      this.index = (this.index === this.directions.length - 1) ? 0 : ++this.index;
      return this.directions[this.index];
    },
    prev: function () {
      this.index = this.index ? --this.index : (this.directions.length - 1);
      return this.directions[this.index];
    },
  };

   /**
   * Базовый класс для действий над изображениями.
   * (Поворот, масштабирование и прокрутка)
   *
   * @since 5.8.0
   */
  class BaseImageActions extends global.BaseActions {

    constructor(context) {
      super();
      this._settings = new global.ImageDocumentPreviewSettings();
      this._initAttributes(context);
    }

     /**
     * @see Core.preview.BaseActions._initAttributes
     */
    _initAttributes(context) {
      super._initAttributes(context);
      this._html = this._jFrameContents.find('html');
      this._jImage = this._jFrameContents.find('.previewImage:first');
      this._jPlaceholder = this._jFrameContents.find('.placeholder');
      this._placeholderMargin = PLACEHOLDER_MARGIN; 
      this._imageInitialSize = {
        height: +(this._jImage.prop('naturalHeight') || this._jImage.height()),
        width: +(this._jImage.prop('naturalWidth') || this._jImage.width()),
      };
      this._recalculateContainerSize();
    }

    /**
    * Пересчитать размеры контейнера изображения
    *
    * @method _recalculateContainerSize
    * @private
    */
    _recalculateContainerSize() {
      const padding = this._placeholderMargin * 2;
      if (this._isIpad) {
        this._containerSize = {
          height: this._jFrame.parent().height() - padding,
          width: this._jFrame.parent().width() - padding,
        };
      } else {
        this._containerSize = {
          height: this._jFrame.height() - padding,
          width: this._jFrame.width() - padding,
        };
      }
    }

   /**
   * @see Core.preview.BaseActions.setScale
   */
    setScale(key) {
      super.setScale(key);
      this._setScaleValueInDropdownAndButtons(key);

      return this;
    }

    /**
    * Установить размеры для html и body.
    * @function Core.preview.multipage-action._setSizesToHtmlAndBody
    * @param {string} key Масштаб.
    * @param {boolean} bodyWidth Размер тела документа.
    * @param {int} scale Масштаб в числовом значении.
    * @param {string} cssTransformOrigin Значение начальной точки трансформации.
    * @param {boolean} isNeedMargin Определяет нужен ли дополнительный отступ для картинки.
    * @since 5.8.0
    * @private    
    */
    _setSizesToHtmlAndBody(key, bodyWidth, scale, cssTransformOrigin, isNeedMargin = true) {
      if (key === 'w') {
        this._html.css({
          margin: '',
          transform: '',
          transformOrigin: '',
        });
        this._jFrame.contents().find('body').css({
          margin: (isNeedMargin ? '8px' : ''),
          width: bodyWidth,
          transform: `scale(${scale})`,
          transformOrigin: 'left top',
        });
      }
      else {
        // Изменить масштаб и указать отступы слева и справа, чтобы при изменении масштаба не появлялся горизонтальный скрол
        this._html.css({
          margin: '',
          transform: `scale(${scale})`,
          transformOrigin: cssTransformOrigin,
        });
        this._jFrame.contents().find('body').css({
          margin: '',
          transform: '',
          transformOrigin: '',
        });
      }
    }

    /**
    * Установить текущий масштаб в выпадайке масштаба и на кнопках масштабирования.
    *
    * @method _setScaleValueInDropdownAndButtons
    * @param {string} key Масштаб
    * @private
    */
    _setScaleValueInDropdownAndButtons(key) {
      const isScaleAlreadySet = this._setScaleValueInDropdown(key);
      if (!isScaleAlreadySet) {
        $('.fit-to').removeClass('selected');
        const buttonKey = new Map([
          [PREVIEW_SCALE.FIT_HEIGHT, 'fitToHeight'],
          [PREVIEW_SCALE.FIT_WIDTH, 'fitToWidth'],
          [PREVIEW_SCALE.FIT_WINDOW, 'fitToWindow'],
        ]).get(key);
        if (buttonKey) {
          window.Core.preview.toolbar.buttons[buttonKey].turnOn();
        }
      }
    }

     /**
     * Установить масштаб относительно области предпросмотра.
     *
     * @method _calculateScaleRelativeToContainer
     * @param {string} initialWidth Начальная ширина.
     * @param {string} initialHeight Начальная высотаы.
     * @param {string} key Способ масштабирования (одно из значений PREVIEW_SCALE).
     * @private
     * @return {number} Масштаб.
     */
    _calculateScaleRelativeToContainer(initialWidth, initialHeight, key) {
      let scale;
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      switch (key) {
        case PREVIEW_SCALE.FIT_HEIGHT: {
          const initSize = shouldFlipHeightAndWidth ? initialWidth : initialHeight;
          scale = this._containerSize.height / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WIDTH: {
          const initSize = shouldFlipHeightAndWidth ? initialHeight : initialWidth;
          scale = this._containerSize.width / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WINDOW: {
          scale = shouldFlipHeightAndWidth ?
            Math.min(this._containerSize.width / initialHeight, this._containerSize.height / initialWidth) :
            Math.min(this._containerSize.width / initialWidth, this._containerSize.height / initialHeight);
        }
      }
      return (+key) / 100 || scale;
    }

    /**
    * Повернуть страницы документа по часовой стрелке
    *
    * @method rotateCW
    * @return {Core.preview.scrolling}
    */
    rotateCW() {
      this._rotatePages(Directions.next());
      return this;
    }

    /**
     * Повернуть страницы документа против часовой стрелки
     *
     * @method rotateCCW
     * @return {Core.preview.scrolling}
     */
    rotateCCW() {
      this._rotatePages(Directions.prev());
      return this;
    }

    /**
     * @see BaseActions.onResize
     */
    onResize() {
      this._recalculateContainerSize();
      // Если масштабирование относительно размера контейнера, то применим его заново
      if (!+this._settings.previewScale) {
        this.setScale();
      }
    }
  }

  global.BaseImageActions = BaseImageActions;
})(window.Core.preview);